/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var CellStatus;
(function (CellStatus) {
    CellStatus[CellStatus["DEFAULT"] = 0] = "DEFAULT";
    CellStatus[CellStatus["TOPDOWNED"] = 1] = "TOPDOWNED";
    CellStatus[CellStatus["TOPDOWN"] = 2] = "TOPDOWN";
    CellStatus[CellStatus["SUBMODEL"] = 4] = "SUBMODEL";
    CellStatus[CellStatus["CALCULATED"] = 5] = "CALCULATED";
    CellStatus[CellStatus["AGGREGATED"] = 6] = "AGGREGATED";
})(CellStatus || (CellStatus = {}));
export function CellStatusFromJSON(json) {
    return CellStatusFromJSONTyped(json, false);
}
export function CellStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CellStatusToJSON(value) {
    return value;
}
